module.exports = __webpack_public_path__ + "static/media/ic_mastercard.60a1cf0d.svg";